module.exports = __webpack_public_path__ + "static/media/transport_icon.62ed4593.svg";